import * as React from 'react';
import { observer } from 'mobx-react';
import BodyLeft from './BodyLeft';
import BodyRight from './BodyRight';
import { ExperienceResource } from '../../../../../../../../../../../../Types';

export interface Props {
  resource: ExperienceResource;
  intercomTarget?: string;
}

const Body: React.FC<Props> = ({ resource, intercomTarget }) => (
  <div
    className="border-gray-20 flex border-b-1 border-solid py-10 last:border-b-0"
    data-intercom-target={intercomTarget}
  >
    <BodyLeft resource={resource} />
    <BodyRight resource={resource} />
  </div>
);

export default observer(Body);
